import { ChangeDetectorRef, QueryList } from '@angular/core';
import { IFormObjectComponent } from './form-object.component';

export interface IFormObjectListComponent<TObject> {
  formCompleted: boolean;
  validateForm(): void;
  add(newObject: TObject): void
  remove(index: number): void
  reset(): void;
}

export abstract class FormObjectListComponent<TFormObjectComponent extends IFormObjectComponent,
                                              TObject>
    implements IFormObjectListComponent<TObject> {
  public abstract objectForms: QueryList<TFormObjectComponent>;
  public objectList: TObject[] = [];
  public formCompleted: boolean = false;

  constructor(public changeDetectorRef: ChangeDetectorRef) {}

  //** Validates the customer form and sets formCompleted to valid or invalid */
  public validateForm(): void {
    this.objectForms.forEach(item => {
      item?.validateForm();
    });

    // If any child forms are invalid (not completed), return not completed.
    this.formCompleted = !this.objectForms.some(item => !item.formCompleted);
  }

  public add(newObject: TObject): void {
    // Validate the existing collections are filled before adding more.
    // TODO: Should this validate AND add?
    // this.validateForm();
    // if (!this.formCompleted) return;

    this.objectList.push(newObject);
  }

  public remove(index: number): void {
    if (index < this.objectList.length) {
      this.objectList.splice(index, 1);
    }

    // Force update UI. Currently used to update totals, but hoping there is a better way to do this.
    // TODO: implement with a UI service or RXJS streams to achieve this, manually calling this is very expensive
    this.changeDetectorRef.detectChanges();
  }

  /** Resets the form. */
  public reset(): void {
    this.objectList = [ ];

    this.objectForms.forEach(item => {
      item.reset();
    });

    this.formCompleted = false;
  }
}
